import React, { useState } from 'react';
import gameService from '../services/gameService';
import '../styles/pixel-art.css';

const Card = ({ card, onClick, selected, disabled, size = 'normal', faceDown = false }) => {
  const [imageExists, setImageExists] = useState(true);
  const [imageLoaded, setImageLoaded] = useState(false);

  if (!card && !faceDown) return null;
  if (!faceDown && (!card || !card.suit || !card.value)) return null;

  const cardDisplay = faceDown ? '?' : gameService.getCardDisplay(card);
  const cardColor = faceDown ? 'blue' : gameService.getCardColor(card);

  // Generate image path based on card value only
  const getCardImagePath = (card) => {
    if (!card || !card.value) return null;
    return `/cards/${card.value}.png`;
  };

  const cardImagePath = !faceDown && card ? getCardImagePath(card) : null;

  const handleClick = () => {
    if (!disabled && onClick) {
      onClick(card);
    }
  };

  const sizeClass = size === 'small' ? 'card-small' : size === 'large' ? 'card-large' : '';

  return (
    <div
      className={`card ${sizeClass} ${selected ? 'card-selected' : ''} ${disabled ? 'card-disabled' : ''} ${faceDown ? 'card-back' : ''}`}
      onClick={handleClick}
      style={{
        cursor: disabled ? 'not-allowed' : onClick ? 'pointer' : 'default',
        color: cardColor
      }}
    >
      {faceDown ? (
        <div className="card-back-pattern">
          <div className="card-back-symbol">HARBOR</div>
        </div>
      ) : (
        <>
          <div className="card-corner card-corner-top">
            <div className="card-value">{card.value}</div>
            <div className="card-suit">{cardDisplay.slice(-1)}</div>
          </div>
          <div className="card-center">
            {imageExists && cardImagePath ? (
              <img
                src={cardImagePath}
                alt={`${card.value} of ${card.suit}`}
                className="card-image"
                onLoad={() => setImageLoaded(true)}
                onError={() => setImageExists(false)}
                style={{ display: imageLoaded ? 'block' : 'none' }}
              />
            ) : null}
            {(!imageExists || !imageLoaded) && (
              <div className="card-main-symbol">{cardDisplay.slice(-1)}</div>
            )}
          </div>
          <div className="card-corner card-corner-bottom">
            <div className="card-value">{card.value}</div>
            <div className="card-suit">{cardDisplay.slice(-1)}</div>
          </div>
          {selected && <div className="card-selected-indicator">✓</div>}
        </>
      )}
    </div>
  );
};

export default Card;
